// extracted by mini-css-extract-plugin
module.exports = {"productionSlug":"ProductionListing_productionSlug__aRAC6","productionSlugOverview":"ProductionListing_productionSlugOverview__kSecY"};